import styled from 'styled-components';
import { Box } from '@latitude/box';
import { Link } from '@latitude/link';
import { Heading1 } from '@latitude/heading';
import { Text } from '@latitude/text';
import { BREAKPOINT, COLOR, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT, MARGIN } from '@latitude/core/utils/constants';
var HeroLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "Herostyles__HeroLink",
  componentId: "sc-9s6cvq-0"
})(["max-width:160px;"]);
var HeroContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Herostyles__HeroContainer",
  componentId: "sc-9s6cvq-1"
})(["position:relative;padding:0;overflow:hidden;min-height:280px;", ";"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor && "background-color: " + backgroundColor + ";";
});
var HeroContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "Herostyles__HeroContent",
  componentId: "sc-9s6cvq-2"
})(["position:relative;z-index:2;padding:24px 0;background-color:", ";@media (min-width:", "){width:50%;padding:0 0 48px;padding:80px 0 48px;background-color:transparent;order:-1;}", ""], function (_ref2) {
  var transparentBg = _ref2.transparentBg;
  return transparentBg ? 'transparent' : '#fff';
}, BREAKPOINT.MD, function (_ref3) {
  var simple = _ref3.simple;
  return simple && "\n      background: transparent;\n      @media (min-width: 0) {\n        padding: 114px 0\n      }\n      @media (min-width: " + BREAKPOINT.LG + ") {\n        padding: 100px 0\n      }";
});
var HeroContentInner = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Herostyles__HeroContentInner",
  componentId: "sc-9s6cvq-3"
})(["margin:0 auto;"]);
var HeroFootnote = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Herostyles__HeroFootnote",
  componentId: "sc-9s6cvq-4"
})(["font-size:", ";font-weight:", ";line-height:", ";margin-top:", ";@media (min-width:", "){margin-top:", ";}"], FONT_SIZE.SMALL, FONT_WEIGHT.LIGHT, LINE_HEIGHT.TIGHT.SMALL, MARGIN.M24, BREAKPOINT.LG, MARGIN.M40);
var HeroImage = /*#__PURE__*/styled.div.withConfig({
  displayName: "Herostyles__HeroImage",
  componentId: "sc-9s6cvq-5"
})(["position:relative;z-index:1;width:100%;height:280px;@media (min-width:", "){width:50%;height:auto;}@media (min-width:", "){width:50%;}"], BREAKPOINT.MD, BREAKPOINT.LG);
var HeroInner = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Herostyles__HeroInner",
  componentId: "sc-9s6cvq-6"
})(["position:relative;margin:0 auto;padding:0;display:flex;flex-direction:column;@media (min-width:", "){flex-direction:row;justify-content:space-between;max-width:calc(", " - 30px);}@media (min-width:", "){max-width:calc(", " - 30px);}@media (min-width:", "){max-width:calc(1140px - 30px);}"], BREAKPOINT.MD, BREAKPOINT.MD, BREAKPOINT.LG, BREAKPOINT.LG, BREAKPOINT.XL);
var HeroText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Herostyles__HeroText",
  componentId: "sc-9s6cvq-7"
})(["margin-bottom:24px;font-size:", ";line-height:", ";color:", ";@media (min-width:", "){margin-bottom:32px;margin-right:32px;font-size:", ";line-height:27px;}"], FONT_SIZE.NORMAL, LINE_HEIGHT.STANDARD.SMALL, COLOR.GREY75, BREAKPOINT.LG, FONT_SIZE.LARGE);
var HeroTitle = /*#__PURE__*/styled(Heading1).withConfig({
  displayName: "Herostyles__HeroTitle",
  componentId: "sc-9s6cvq-8"
})(["font-size:32px;line-height:36px;font-weight:600;margin-bottom:16px;color:", ";@media (min-width:", "){font-size:48px;line-height:56px;margin-bottom:24px;}"], COLOR.BLACK, BREAKPOINT.LG);
export { HeroContainer, HeroContent, HeroContentInner, HeroFootnote, HeroImage, HeroInner, HeroLink, HeroText, HeroTitle };